import { render } from "./PostStatsModal.vue?vue&type=template&id=719749e8&scoped=true"
import script from "./PostStatsModal.vue?vue&type=script&lang=js"
export * from "./PostStatsModal.vue?vue&type=script&lang=js"

import "./post-stats-modal.scss?vue&type=style&index=0&id=719749e8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719749e8"]])

export default __exports__